// A shared stick-silhouette with a teal highlight over the chosen region — matching the
// design's body-area cards. One base figure + a small map of highlight overlays keeps
// this to a few lines instead of ten bespoke SVGs.
import type { CSSProperties } from 'react';

const BASE = '#C4D2D7';
const HL = '#21ACBE';

const HIGHLIGHTS: Record<string, JSX.Element> = {
  Neck: <rect x={13} y={11} width={6} height={5} rx={2.5} fill={HL} />,
  Back: <rect x={10} y={15} width={12} height={22} rx={5} fill={HL} />,
  Shoulder: (
    <>
      <circle cx={7} cy={17.5} r={4} fill={HL} />
      <circle cx={25} cy={17.5} r={4} fill={HL} />
    </>
  ),
  Elbow: (
    <>
      <circle cx={6} cy={27} r={3.2} fill={HL} />
      <circle cx={26} cy={27} r={3.2} fill={HL} />
    </>
  ),
  Wrist: (
    <>
      <rect x={3.5} y={33} width={5} height={4} rx={2} fill={HL} />
      <rect x={23.5} y={33} width={5} height={4} rx={2} fill={HL} />
    </>
  ),
  Hand: (
    <>
      <rect x={3} y={38} width={6} height={6} rx={3} fill={HL} />
      <rect x={23} y={38} width={6} height={6} rx={3} fill={HL} />
    </>
  ),
  Hip: <rect x={10} y={32} width={12} height={7} rx={3.5} fill={HL} />,
  Knee: (
    <>
      <circle cx={13} cy={46} r={3.4} fill={HL} />
      <circle cx={19} cy={46} r={3.4} fill={HL} />
    </>
  ),
  Foot: (
    <>
      <rect x={9.5} y={57} width={6} height={4.5} rx={2} fill={HL} />
      <rect x={16.5} y={57} width={6} height={4.5} rx={2} fill={HL} />
    </>
  ),
  Ankle: (
    <>
      <rect x={10.5} y={53} width={5} height={4} rx={2} fill={HL} />
      <rect x={16.5} y={53} width={5} height={4} rx={2} fill={HL} />
    </>
  ),
};

export function BodyIcon({ area, style }: { area: string; style?: CSSProperties }) {
  return (
    <svg width={24} height={48} viewBox="0 0 32 64" fill="none" style={{ flexShrink: 0, ...style }} aria-hidden>
      <circle cx={16} cy={7} r={6} fill={BASE} />
      <rect x={10} y={15} width={12} height={22} rx={5} fill={BASE} />
      <rect x={3.5} y={16} width={5} height={22} rx={2.5} fill={BASE} />
      <rect x={23.5} y={16} width={5} height={22} rx={2.5} fill={BASE} />
      <rect x={10.5} y={36} width={5} height={25} rx={2.5} fill={BASE} />
      <rect x={16.5} y={36} width={5} height={25} rx={2.5} fill={BASE} />
      {HIGHLIGHTS[area] ?? null}
    </svg>
  );
}
